import { WebcamIcon } from './WebcamIcon';

/**
 * author: Chris Litherland
 * id 03483AFB-9D53-4E10-B00C-1095C1873276
 * name webcam
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/webcam.svg
 * tags
 * - Video / Movie 
 * - Home Automation 
 */
export const WebCameraIcon = WebcamIcon;
export default WebCameraIcon